import React from 'react';
import { motion } from 'framer-motion';
import { Scale, Shield, Users, FileText, Globe, Briefcase } from 'lucide-react';
const practices = [{
  title: 'Family Law',
  description: 'Compassionate representation for divorce, child custody, and support matters.',
  icon: Users
}, {
  title: 'Criminal Defense',
  description: 'Aggressive defense strategies protecting your rights and your future.',
  icon: Shield
}, {
  title: 'Personal Injury',
  description: "Fighting for maximum compensation when you've been injured by negligence.",
  icon: Scale
}, {
  title: 'Estate Planning',
  description: 'Securing your legacy with comprehensive wills, trusts, and probate services.',
  icon: FileText
}, {
  title: 'Immigration',
  description: 'Navigating complex immigration laws to keep families together and secure visas.',
  icon: Globe
}, {
  title: 'Business Law',
  description: 'Strategic legal counsel for business formation, contracts, and litigation.',
  icon: Briefcase
}];
export function PracticeAreas() {
  return <section id="practice-areas" className="py-16 md:py-24 bg-gray-50" data-id="element-144">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-145">
        <div className="text-center mb-12 md:mb-16" data-id="element-146">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl sm:text-4xl md:text-5xl text-[#1a1a1a] font-bold mb-4" data-id="element-147">
            Our Practice Areas
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '80px'
        }} viewport={{
          once: true
        }} className="h-1 bg-[#7c0a0a] mx-auto mb-6" data-id="element-148" />
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-149">
            Providing comprehensive legal solutions across multiple disciplines
            to serve the diverse needs of our Orange County community.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-150">
          {practices.map((practice, index) => <motion.div key={practice.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 sm:p-8 border border-gray-200 hover:border-[#c9a35a] transition-all duration-300 group hover:shadow-xl" data-id="element-151">
              <div className="w-14 h-14 bg-gray-50 group-hover:bg-[#7c0a0a] flex items-center justify-center mb-6 transition-colors duration-300" data-id="element-152">
                <practice.icon className="w-7 h-7 text-[#7c0a0a] group-hover:text-white transition-colors duration-300" data-id="element-153" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-[#1a1a1a] mb-3 group-hover:text-[#7c0a0a] transition-colors" data-id="element-154">
                {practice.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6" data-id="element-155">
                {practice.description}
              </p>
              <a href="#contact" className="text-[#c9a35a] font-semibold uppercase tracking-wider text-sm hover:text-[#7c0a0a] transition-colors flex items-center gap-2" data-id="element-156">
                Learn More <span className="text-lg" data-id="element-157">→</span>
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}